<div class="match-category-chip-wrapper">
    <p class="match-category-chip"
       [ngClass]="'match-category-chip-' + matchCategory?.toLowerCase()"
       [attr.data-qa-id]="dataQaId">
        <ng-container [ngSwitch]="matchCategory?.toLowerCase()">
            <span *ngSwitchCase="'high'" class="material-symbols-outlined">person_check</span>
            <span *ngSwitchCase="'medium'" class="material-symbols-outlined">person_alert</span>
            <span *ngSwitchCase="'low'" class="material-symbols-outlined">person_cancel</span>
        </ng-container>
        <span class="match-category-text">
            {{matchCategory}}
        </span>
    </p>
</div>
